// Stylized Greek God statue silhouette - inline SVG line-art
// Used as a faded background watermark behind hero / sections.
import React from "react";

const StatueSilhouette = ({ className = "", style = {} }) => {
  return (
    <svg
      viewBox="0 0 400 700"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Head */}
      <path d="M205 70 c-22 0 -38 18 -40 40 c-1 14 4 28 4 36 c0 8 -4 14 -4 20 c0 10 12 22 22 26 c4 2 10 4 18 4 c8 0 14 -2 18 -4 c10 -4 22 -16 22 -26 c0 -6 -4 -12 -4 -20 c0 -8 5 -22 4 -36 c-2 -22 -18 -40 -40 -40 z" />
      {/* Hair waves */}
      <path d="M170 60 c4 -10 14 -18 26 -22 M230 60 c-4 -10 -14 -18 -26 -22 M178 50 c6 -8 14 -12 22 -14 M222 50 c-6 -8 -14 -12 -22 -14" />
      {/* Laurel hint */}
      <path d="M155 55 c8 -6 16 -10 22 -10 M245 55 c-8 -6 -16 -10 -22 -10" />
      {/* Neck */}
      <path d="M188 184 c-2 12 -2 22 -4 30 M212 184 c2 12 2 22 4 30" />
      {/* Shoulders/traps */}
      <path d="M184 214 c-30 4 -60 18 -78 36 c-10 10 -16 22 -18 34 M216 214 c30 4 60 18 78 36 c10 10 16 22 18 34" />
      {/* Chest pecs outline */}
      <path d="M118 270 c0 30 14 56 40 70 c12 6 26 8 42 8 M282 270 c0 30 -14 56 -40 70 c-12 6 -26 8 -42 8" />
      <path d="M200 348 c-26 0 -50 -10 -68 -28 M200 348 c26 0 50 -10 68 -28" />
      {/* Sternum / abs line */}
      <path d="M200 234 l0 220" />
      <path d="M178 360 l44 0 M178 390 l44 0 M178 418 l44 0 M178 446 l44 0" />
      {/* Arms upper */}
      <path d="M108 290 c-14 18 -24 40 -28 64 c-4 22 -2 44 4 64 M292 290 c14 18 24 40 28 64 c4 22 2 44 -4 64" />
      {/* Biceps mass */}
      <path d="M84 376 c-8 24 -6 50 6 72 M316 376 c8 24 6 50 -6 72" />
      {/* Forearms */}
      <path d="M90 448 c-2 30 4 60 18 88 M310 448 c2 30 -4 60 -18 88" />
      {/* Torso sides to waist */}
      <path d="M132 360 c-6 30 -8 60 -4 90 c2 16 6 30 14 42 M268 360 c6 30 8 60 4 90 c-2 16 -6 30 -14 42" />
      {/* Waist taper */}
      <path d="M148 492 c10 14 30 22 52 22 c22 0 42 -8 52 -22" />
      {/* Hips drape (toga hint) */}
      <path d="M138 520 c-6 30 -2 60 8 88 c10 26 26 50 38 70 M262 520 c6 30 2 60 -8 88 c-10 26 -26 50 -38 70" />
      <path d="M150 540 c20 8 80 8 100 0 M156 580 c18 6 70 6 88 0 M162 620 c14 4 62 4 76 0" />
      {/* Pedestal */}
      <path d="M120 670 l160 0 l8 14 l-176 0 z" />
    </svg>
  );
};

export default StatueSilhouette;
